import { render } from "./ShiftTable.vue?vue&type=template&id=2c6a17a1"
import script from "./ShiftTable.vue?vue&type=script&lang=js"
export * from "./ShiftTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__